/* eslint-disable */
import dicts from "./example"

export const branchMemberCols = [
  {
    title: '姓名',
    key: 'name',
    tooltip: true,
    minWidth: 160,
    align: 'center',
  },
  {
    title: '性别',
    slot: 'gender',
    width: 100,
    align: 'center',
  },
  {
    title: '出生年月',
    key: 'birthday',
    width: 160,
    tooltip: true,
    align: 'center',
  },
  {
    title: '加入民革时间',
    key: 'joinTime',
    width: 180,
    tooltip: true,
    align: 'center',
  },
  {
    title: '工作单位及职务',
    key: 'workJob',
    width: 240,
    tooltip: true,
    align: 'center',
  },
  {
    title: '职称',
    key: 'jobCall',
    width: 200,
    tooltip: true,
    align: 'center',
  },
  {
    title: '民革职务',
    key: 'mingeJob',
    width: 120,
    align: 'center',
  },
  {
    title: '人大、政协及特邀约职务',
    key: 'rdzxJob',
    width: 200,
    align: 'center',
  },
  {
    title: '联系方式',
    key: 'phone',
    minWidth: 140,
    align: 'center',
  },
  {
    title: '界别',
    slot: 'circles',
    width: 140,
    align: 'center',
  },
  {
    title: '备注',
    key: 'remark',
    minWidth: 140,
    align: 'center',
  },
  {
    title: '操作',
    slot: 'operation',
    width: 160,
    fixed: 'right',
    align: 'center',
  },
]
export const branchMemberForm = {
  attrs: {
    labelWidth: '180px',
    'label-position': 'left',
    rules: {
      name: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
      ],
      birthday: [
        {
          required: true,
          message: '请选择出生年月',
          trigger: 'change',
        },
      ],
    },
  },
  items: [
    {
      label: '姓名',
      prop: 'name',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
     {
      type: 'datepicker',
      label: '出生年月',
      prop: 'birthday',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
    },
    {
      type: 'select',
      label: '性别',
      prop: 'gender',
      options: [
        { label: '男', value: 1 },
        { label: '女', value: 2 },
      ],
    },
    {
      type: 'datepicker',
      label: '加入民革时间',
      prop: 'joinTime',
      clearable: true,
      format: 'yyyy-MM',
      dateType: 'month',
    },
    {
      label: '工作单位及职务',
      prop: 'workJob',
      maxlength: 50,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '职称',
      prop: 'jobCall',
      maxlength: 50,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '民革职务',
      prop: 'mingeJob',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '人大、政协及特邀约职务',
      prop: 'rdzxJob',
      maxlength: 20,
      showWordLimit: true,
      clearable: true,
    },
    {
      label: '联系方式',
      prop: 'phone',
      maxlength: 30,
      showWordLimit: true,
      clearable: true,
    },
    {
      type: 'select',
      label: '界别',
      prop: 'circles',
      options: dicts.circles(),
    },
    {
      label: '备注',
      prop: 'remark',
      maxlength: 100,
      showWordLimit: true,
      clearable: true,
    },
  ],
}